import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import avatar from 'animal-avatar-generator';
import Avatar from '@mui/material/Avatar';
import { v4 as uuid } from 'uuid';

export default function AnimalAvatar({ seed, options = {}, ...avatarProps }) {
  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      if (!seed) {
        seed = uuid();
      }
      const avatarSvg = avatar(seed, options);
      ref.current.innerHTML = avatarSvg;
    }
  }, [ref]);

  return <Avatar {...avatarProps} alt={seed} ref={ref} />;
}

AnimalAvatar.propTypes = {
  seed: PropTypes.string,
  options: PropTypes.object
};
